import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import moment from 'moment';
import isString from 'lodash/isString';
import { formatMoney } from '../../../shared/format';

const Table = ({ table, intl, purse, toggleTransferForm, toggleProtectionForm }) => (
	<div className="table-container wm-history-table">
		<table className="simple-table">
			<thead className="simple-table__head font-roboto-medium">
				<tr>
					{table.headers.map((header, i) => (
						<th
							key={i}
							className={cn({
								[header.className]: header.className
							})}
						>
							{intl(header.title)}
						</th>
					))}
				</tr>
			</thead>
			<tbody className="simple-table__body">
				{table.rows.slice(0).reverse().map((row, i) => (
					<tr key={i} className={cn({
						shaded: row.opertype == 4 || row.opertype == 12
					})}>
						<td>
							<span>{moment(row.datecrt, 'YYYYMMDD HH:mm:ss').format('DD.MM.YYYY HH:mm:ss')}</span>
						</td>
						<td>
							<span className={cn({strong: row.pursesrc == purse.pursename})}>{row.pursesrc}</span>
						</td>
						<td>
							<span className={cn({strong: row.pursedest == purse.pursename})}>{row.pursedest}</span>
						</td>
						<td>
							<span>
								{formatMoney(row.amount)} ({formatMoney(row.comiss)})
								{row.opertype == 4 && ' - not completed'}
								{row.opertype == 12 && ' - refunded'}
							</span>
						</td>
						<td>
							<span>{isString(row.desc) && row.desc}</span>
						</td>
						<td className="actions">
							{
								row.pursesrc == purse.pursename &&
									<a
										href="#"
										onClick={e => {
											e.preventDefault();
											toggleTransferForm({
												purse: row.pursedest,
												amount: row.amount,
												desc: row.desc
											});
										}}
										className="action_transfer"
									/>
							}
							{
								row.pursedest == purse.pursename && row.opertype == 4 &&
									<a
										href="#"
										onClick={e => {
											e.preventDefault();
											toggleProtectionForm({
												id: row.id,
												amount: row.amount,
												desc: row.desc
											});
										}}
										className="action_complete_transfer"
									/>
							}

						</td>
					</tr>
				))}
			</tbody>
		</table>
	</div>
);

Table.propTypes = {
	table: PropTypes.object,
	purse: PropTypes.object,
	toggleTransferForm: PropTypes.func,
	toggleProtectionForm: PropTypes.func,
	intl: PropTypes.func
};

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/wm/components/table/main.js